<template>
  <div class="home" ref="homewrap">
    <div>
      <van-swipe class="my-swipe" style="height: 150px;" :show-indicators="false">
        <van-swipe-item>
          <van-image
              mode="fill"
              height="150"
              width="100%"
              :src="image" alt=""/>
        </van-swipe-item>
        <van-swipe-item>
          <img src="" alt="">
          <van-image
              mode="fill"
              width="100%"
              height="150"
              :src="image" alt=""/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
              mode="fill"
              width="100%"
              height="150"
              :src="image" alt=""/>
        </van-swipe-item>
      </van-swipe>
      <div class="workspace">
        <div class="panel">
          <van-grid :column-num="4" :border="false">
            <van-grid-item icon="photo-o" text="气瓶信息" @click="toTrack"/>
            <van-grid-item icon="paid" text="充装信息" @click="toTankFill"/>
            <van-grid-item icon="photo-o" text="配送中心" @click="toOrderOnline"/>
            <van-grid-item icon="photo-o" text="安全须知" @click=""/>
          </van-grid>
        </div>
      </div>
      <div class="rewending-list" ref="formulaList">
        <div>
          <van-empty v-if="list.length == 0" :description="code"/>
          <div v-for="(item, index) in list" :key="index" class="rewending-item">
            <div class="content">
              <div class="list-item">
                <span class="title">充装单位：</span>
                <span class="value">{{ item.net_name }}</span>
              </div>
              <div class="list-item">
                <span class="title">制造单位：</span>
                <span class="value">{{ item.vender_name }}</span>
              </div>
              <div class="list-item">
                <span class="title">出厂编号：</span>
                <span class="value">{{ item.vender_tank_no }}</span>
              </div>
              <div class="list-item">
                <span class="title">生产年月：</span>
                <span class="value">{{ item.create_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">设计年限：</span>
                <span class="value">{{ item.expire_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">检验机构：</span>
                <span class="value">{{ item.check_name }}</span>
              </div>
              <div class="list-item">
                <span class="title">定期检验日期：</span>
                <span
                    class="value">{{ (item.fix_check_date == null || item.fix_check_date == "") ? '--' : item.fix_check_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">实际检验日期：</span>
                <span
                    class="value">{{ (item.curr_check_date == null || item.curr_check_date == "") ? '--' : item.curr_check_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">使用截止日期：</span>
                <span class="value">{{ item.expire_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">安全评估日期：</span>
                <span class="value">{{ item.estimate_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">终止使用日期：</span>
                <span class="value">{{ item.scrap_date }}</span>
              </div>
              <div class="list-item">
                <span class="title">条形码：</span>
                <span class="value">{{ item.barcode }}</span>
              </div>
              <div class="list-item">
                <span class="title">登记时间：</span>
                <span class="value">{{ item.create_ts }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
      <div class="rewending-list" ref="customer">
        <div>
          <van-empty v-if="list.length == 0" />
          <div v-for="(item, index) in list" :key="index" class="rewending-item" >
            <div class="content" >
              <div class="list-item">
                <span class="title">客户：</span>
                <span class="value">{{item.net_name}}</span>
              </div>
              <div class="list-item">
                <span class="title">联系方式：</span>
                <span class="value">{{item.vender_name}}</span>
              </div>
              <div class="list-item">
                <span class="title">地址：</span>
                <span class="value">{{item.vender_tank_no}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->

    </div>
  </div>
</template>

<script>
//import HelloWorld from '@/components/HelloWorld.vue'
//import BarChart from '@/components//charts/BarChart.vue'
import BetterScroll from 'better-scroll'
import EXIF from 'exif-js'
import moment from 'moment'
import {Toast, Dialog} from 'vant'

export default {
  name: 'Home',
  components: {
    //HelloWorld,
    //BarChart
  },
  data() {
    return {
      image: require('../assets/images/banner.png'),
      scroll: null,
      list: [],
      code: '',
    }
  },
  methods: {
    onLoad() {
      this.loading = true
      Toast.loading({
        message: '加载中',
        duration: 0
      })
      this.$api.post('get_tank_info.php', {barcode: this.code}).then(res => {
        Toast.clear()
        this.loading = false
        if (res.tank.net_id) {
          this.list = [res.tank];
        }
        this.$nextTick(() => {
          this.scroll = new BetterScroll(this.$refs.formulaList, {
            click: true
          })
        })
      })
    },
    toTrack() {
      this.$router.push('track')
    },
    toTankFill() {
      this.$router.push('tank_fill')
    },
    toOrderOnline() {
      window.location.href = "https://gas-h5.yunmaiche.net/wechat/deliver_index";
    },
    checkLogin() {
      const localToken = localStorage.getItem('token')
      const remoteToken = this.$route.query.token
      const remoteOperator = this.$route.query.operator
      if (remoteToken && remoteOperator) {
        localStorage.setItem('token', remoteToken)
        localStorage.setItem('operator', remoteOperator)
      } else {
        if (!localToken) {
          this.$router.push('login')
        }
      }
    },
    getImage() {
      var cmr = plus.camera.getCamera();
      cmr.captureImage(function (p) {
        plus.io.resolveLocalFileSystemURL(p, function (entry) {
          entry.file(file => {
            const reader = new plus.io.FileReader()
            reader.readAsDataURL(file)
            reader.onloadend = (e) => {
              console.log(e.target.result)
            };
          })
        }, function (e) {
          plus.nativeUI.toast("读取拍照文件错误：" + e.message);
        });
      }, function (e) {
        console.log('失败：' + e.message);
      }, {filename: '_doc/camera/', index: 1});
    },
    pickImage() {
      plus.gallery.pick(function (path) {
        plus.io.getImageInfo({
          src: path,
          success: (data) => {
            console.log(JSON.stringify(data))
          }
        })
        // plus.io.resolveLocalFileSystemURL(path, function(entry) {
        // 	entry.file(file => {
        // 		console.log('来了')
        // 		console.log(JSON.stringify(file))
        // 		const reader = new plus.io.FileReader()
        // 		reader.readAsDataURL(file)
        // 		reader.onloadend = (e) => {
        // 			let img = new Image();
        // 			img.src = e.target.result;
        // 			img.onload = function () {
        // 				EXIF.getData(this, function() {
        // 					console.log(JSON.stringify(EXIF.getAllTags(this)))
        // 				});
        // 			}
        // 		};
        // 	})
        // }, function(e) {
        // 	plus.nativeUI.toast("读取拍照文件错误：" + e.message);
        // });
      }, function (e) {
        console.log("取消选择图片");
      }, {filter: "image"});
    },
    toReWenDingCheck() {
      this.$router.push('rewending_check_list')
    }
  },
  mounted() {
    this.scroll = new BetterScroll(this.$refs.homewrap, {
      click: true
    })
  },
  created() {
    let code = this.$route.query.code;
    if (code && code != '') {
     /* let prefix = code.substring(0, 5)
      let codeNum = Number(code.substring(5, code.length))
      console.info(codeNum, prefix)
      //气站
      let prefixArray = ['XFX21']

      let codeRanges = [
        [33011, 33510],
        [38001, 39999],
        [40000, 40571],
        [41018, 41518],
        [42518, 44532],
        [46158, 46580]
      ]
      if (prefixArray.includes(prefix)) {
        let isOther = false
        for (let i = 0; i < codeRanges.length; i++) {
          let range = codeRanges[i]
          if (codeNum >= range[0] && codeNum <= range[1]) {
            isOther = true
            break
          }
        }
        console.info( '-----是否需跳转---------',isOther)
        if(isOther){
          window.location.href = `https://qp.cnjifen.cn/a.ashx?d=${code}`
        }else{
          localStorage.setItem('code', code);
          this.code = code;
          this.onLoad();
        }
      }else{
        localStorage.setItem('code', code);
        this.code = code;
        this.onLoad();
      }*/
      this.$api.post('is_redirect.php', {barcode: code}).then(res => {
        if (res.is_redirect && res.is_redirect===1) {
          window.location.href = `https://qp.cnjifen.cn/a.ashx?d=${code}`
        }else{
          localStorage.setItem('code', code);
          this.code = code;
          this.onLoad();
        }
      })
    } else {
      code = localStorage.getItem('code');
      this.code = code;
      this.onLoad();
    }



  }
}
</script>

<style lang="less">
.home {
  background-color: #fcfcfc;
}

.workspace {
  background: #fff;
  min-height: calc(100% - 220px);
  margin-top: 10px;
  padding-bottom: 30px;
}

.panel {
  height: auto;
  overflow: hidden;

  .panel-title {
    margin: 5px 12px;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    font-weight: 500;
  }
}

.van-grid-item__content {
  .van-icon {
    color: #fff;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2A8DFF;
    border-radius: 10px;
  }
}

.van-grid-item {
  &:nth-child(1),
  &:nth-child(10) {
    .van-grid-item__content {
      .van-icon {
        background-color: #2A8DFF;
      }
    }
  }

  &:nth-child(2),
  &:nth-child(9) {
    .van-grid-item__content {
      .van-icon {
        background-color: #FE9857;
      }
    }
  }

  &:nth-child(2),
  &:nth-child(8) {
    .van-grid-item__content {
      .van-icon {
        background-color: #FE9857;
      }
    }
  }

  &:nth-child(3),
  &:nth-child(7) {
    .van-grid-item__content {
      .van-icon {
        background-color: #23B899;
      }
    }
  }

  &:nth-child(4),
  &:nth-child(6) {
    .van-grid-item__content {
      .van-icon {
        background-color: #7A79FF;
      }
    }
  }

  &:nth-child(5) {
    .van-grid-item__content {
      .van-icon {
        background-color: #D52648;
      }
    }
  }
}

.rewending-list {
  top: 0;
  left: 0;
  right: 0;
  bottom: 55px;
  padding-bottom: 60px;
  overflow: scroll;
  background-color: #fafafa;

  .rewending-item {
    margin-top: 5px;
    background-color: #fff;
    padding: 10px 16px;

    .list-item {
      display: flex;
      justify-content: space-between;

      span:nth-child(2) {
        padding: 5px 0;
        color: #a3a3a3;

        span:nth-child(1) {
          font-size: 16px;
        }
      }

      span:nth-child(1) {
        padding: 5px 0;
        color: #3c3c3c;

        span:nth-child(1) {
          font-size: 16px;
        }
      }

      &:nth-child(1) {
        padding: 5px 0;

        span:nth-child(1) {
          font-size: 16px;
        }
      }
    }
  }
}


</style>
